import { useField } from "formik";
import { SharedserviceMelcoModelsAlphabetListItem } from "melco-shared-logic";
import { useMessage } from "melco-ui";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useAddFonts = () => {
  const { t } = useTranslation();

  const message = useMessage();

  const [{ value: fonts }, , { setValue: setFonts }] =
    useField<SharedserviceMelcoModelsAlphabetListItem[]>("alphabet_list");

  const addFonts = useCallback(
    (toAdd: SharedserviceMelcoModelsAlphabetListItem[]) => {
      const alreadyAddedIds = fonts.map((f) => f.id!);
      const withoutAlreadAdded = toAdd.filter(
        (f) => !alreadyAddedIds.includes(f.id!)
      );

      setFonts([...(fonts ?? []), ...withoutAlreadAdded]);

      message.success(
        t("font_collections.actions.add_fonts.actions.added", {
          count: withoutAlreadAdded.length,
        })
      );
    },
    [fonts, setFonts, t, message]
  );

  const removeFonts = (toRemove: SharedserviceMelcoModelsAlphabetListItem[]) => {
    const idsToRemove = toRemove.map((f) => f.id!);
    setFonts(fonts.filter((f) => !idsToRemove.includes(f.id!)));
  };

  const isAlreadyAdded = (font: SharedserviceMelcoModelsAlphabetListItem) =>
    font.id && fonts.find((f) => f.id === font.id);

  return {
    fonts,
    addFonts,
    removeFonts,
    isAlreadyAdded,
  };
};
